import { StatusReferenceBase } from "./status-reference.base"

export class OrderDeliveryStatusReferenceModel extends StatusReferenceBase {
    public orderDeliveryStatusCode: string;
    public orderDeliveryStatusName: string;
    public statusCode: string;
    public highlightColor: string;
}